export default __webpack_public_path__ + "static/media/outlook.a8cc8502.svg";